import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Switch,
  Tooltip,
  Typography
} from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";

const DeleteRowsDialog = ({
  open,
  selectedCount,
  onCancel,
  onConfirm,
  title = "Delete Selected Rows?",
  resourceLabel = "the OSM raw data collection",
  warningText = "This action cannot be undone. Are you sure?",
  confirmLabel,
  blacklistOptOutChecked,
  onToggleBlacklistOptOut
}) => (
  <Dialog
    open={open}
    onClose={onCancel}
    aria-labelledby="delete-dialog-title"
    aria-describedby="delete-dialog-description"
  >
    <DialogTitle id="delete-dialog-title" sx={{ color: "error.main" }}>
      {title}
    </DialogTitle>
    <DialogContent>
      <DialogContentText id="delete-dialog-description">
        You are about to permanently delete {selectedCount} row{selectedCount !== 1 ? "s" : ""} from {resourceLabel}.
        <br />
        <br />
        <strong>{warningText}</strong>
      </DialogContentText>

      {typeof blacklistOptOutChecked === "boolean" && (
        <Box mt={3}>
          <FormControlLabel
            control={(
              <Switch
                checked={blacklistOptOutChecked}
                onChange={(e) => onToggleBlacklistOptOut?.(e.target.checked)}
                color="warning"
              />
            )}
            label={(
              <Box display="flex" alignItems="center" gap={0.75}>
                <Typography variant="body2">
                  Do not include these venues in the excluded list.
                </Typography>
                <Tooltip
                  title="Venues deleted from the OSM fetching service will automatically be added to the excluded list, and will not show up in future searches. These can be removed from the Excluded Venues page. Toggle this to not add these venues to the excluded list."
                  placement="top"
                  arrow
                >
                  <InfoOutlined fontSize="small" color="action" />
                </Tooltip>
              </Box>
            )}
          />
        </Box>
      )}
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} color="primary">
        Cancel
      </Button>
      <Button onClick={onConfirm} color="error" variant="contained" autoFocus>
        {confirmLabel || `Yes, Delete ${selectedCount} Row${selectedCount !== 1 ? "s" : ""}`}
      </Button>
    </DialogActions>
  </Dialog>
);

export default DeleteRowsDialog;
